/**
 * Shared glass (frosted) style constants for the Admin interface.
 * Single source of truth – tweak here to update all admin pages at once.
 */

/** Hoverable metric / stat cards (with lift effect) */
export const glassCard =
  "bg-white/[0.10] backdrop-blur-[20px] border border-white/20 shadow-[0_8px_32px_0_rgba(0,0,0,0.06)] rounded-2xl transition-all duration-300 hover:-translate-y-0.5 hover:bg-white/[0.16] hover:shadow-[0_12px_40px_0_rgba(0,0,0,0.08)]";

/** Non-hoverable containers (tables, forms, large panels) */
export const glassCardStatic =
  "bg-white/[0.10] backdrop-blur-[20px] border border-white/20 shadow-[0_8px_32px_0_rgba(0,0,0,0.06)] rounded-2xl";

/** Lighter variant for nested / secondary cards */
export const glassCardLight =
  "bg-white/[0.08] backdrop-blur-[20px] border border-white/20 shadow-[0_8px_32px_0_rgba(0,0,0,0.06)] rounded-2xl";

/** Translucent tab navigation bars */
export const glassTabsList =
  "bg-white/[0.08] backdrop-blur-[20px] border border-white/20 rounded-xl";
